// import clientes from './clientes';
import representantes from './representantes';
import pedidos from './pedidos';
import charts from './charts';
import filters from './filters';
import wallet from './wallet';
import revenues from './revenues';
import customer from './customer';
import duplicates from './duplicates';
import canceledOrders from './canceledOrders';
import performance from './performance';
import route from './route';

export default {
	representantes,
	pedidos,
	charts,
	filters,
	wallet,
	revenues,
	customer,
	duplicates,
	canceledOrders,
	performance,
	route,
};
